<p-treeTable [value]="versionChangesTree"
             [columns]="versionChangesColumns"
             [scrollable]="true"
             [selection]="[]"
             dataKey="id"
             sortField="index"
             tableStyleClass="version-changes-tree">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <ng-container *ngFor="let column of columns; let i = index">
                <ng-container *ngIf="!column?.hide?.()">

                    <th>{{ column.header }}</th>

                </ng-container>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowNode let-change="rowData" let-columns="columns">
        <tr [ttRow]="rowNode">
            <ng-container *ngFor="let column of columns; let i = index">
                <ng-container *ngIf="!column?.hide?.()">

                    <!--Normal cell display-->
                    <td *ngIf="!column.editable?.(change); else editableCell">
                        <p-treeTableToggler [rowNode]="rowNode" *ngIf="i === 0"/>
                        <p-treeTableCheckbox [value]="rowNode" *ngIf="i === 0"/>
                        <span [style]="columnStyle(column, change, i, rowNode.level)">
                            {{ change[column.field] }}
                        </span>
                    </td>

                    <!--Editable cell display (for editing default values)-->
                    <ng-template #editableCell>
                        <td ttEditableColumn>
                            <div class="default-value-editor"
                                 [style]="columnStyle(column, change, i, rowNode.level)">
                                <p-treeTableCellEditor #editor>

                                    <!--Uses formio component for input-->
                                    <ng-template pTemplate="input">
                                        <formio [form]="change.form"
                                                [hideLoading]="true"
                                                [submission]="change.formData"
                                                (change)="updateData(change, $event)">
                                        </formio>
                                        <p-button label="Set null"
                                                  (onClick)="clearData(change, editor)">
                                        </p-button>
                                    </ng-template>

                                    <!--Uses formio component for output only if is not empty-->
                                    <ng-template pTemplate="output">
                                        <formio *ngIf="!column.empty?.(change); else emptyCell"
                                                [form]="change.form"
                                                [hideLoading]="true"
                                                [readOnly]="true"
                                                [submission]="change.formData"
                                                class="pointer-events-none">
                                        </formio>
                                        <ng-template #emptyCell>
                                            <span>null</span>
                                        </ng-template>
                                    </ng-template>
                                </p-treeTableCellEditor>
                            </div>
                        </td>
                    </ng-template>

                </ng-container>
            </ng-container>
        </tr>
    </ng-template>
</p-treeTable>